export const referenceList = [
  { value: "Linkedin", label: "Linkedin" },
  { value: "Expos", label: "Expos" },
  { value: "1 on 1 meetings", label: "1 on 1 meetings" },
  { value: "Instagram", label: "Instagram" },
  { value: "Other", label: "Other" },
];
